import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FieldArray } from 'redux-form';
import AdultFields from './AdultFields';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useFlags } from 'launchdarkly-react-client-sdk';
import * as appSelectors from '../../App/selectors';
import * as residentSelectors from '../selectors';

type Props = {
  deleteAdult: Function,
  applicantTypes: Array<any>,
  addAdult: Function,
  applicationType: string,
  isAffordableApplication: boolean,
  primaryResidentId: string,
  onPrimaryChange: Function,
  leaseLocked: boolean,
  prevPrimaryId: string,
  change: Function,
};

function Adults(props: Props) {
  const flags = useFlags();
  const isAffordable =
    props.applicationType === 'Affordable' ||
    (props.applicationType === 'Mixed' && props.isAffordableApplication);
  const { leaseLocked, householdHasOpenCerts } = props;

  return (
    <div className="applicant-grp">
      <div className="block-heading row">
        <h2>Adult(s)</h2>
      </div>
      {/* Only show header row when feature flag is disabled */}
      {!flags?.addlContactInfoResidents && (
        <Row>
          <div className="labels-head container-of-inputs">
            <Col xs={6} sm={1}>
              <label>Type*</label>
            </Col>
            <Col xs={6} sm={1}>
              <label>First*</label>
            </Col>
            <Col xs={6} sm={1}>
              <label>Middle</label>
            </Col>
            <Col xs={6} sm={1}>
              <label>Last*</label>
            </Col>
            <Col xs={6} sm={1}>
              <label>Suffix</label>
            </Col>
            <Col xs={6} sm={1}>
              <label>Preferred Name</label>
            </Col>

            <Col xs={6} sm={1} className="text-center">
              <label>Primary/HOH</label>
            </Col>

            <Col xs={6} sm={isAffordable ? 1 : 2}>
              <label>Relation*</label>
            </Col>
            {isAffordable && (
              <Col xs={6} sm={1}>
                <label>Affordable Relation*</label>
              </Col>
            )}

            <Col xs={6} sm={1}>
              <label>Phone*</label>
            </Col>
            <Col xs={6} sm={2}>
              <label>Email</label>
            </Col>
          </div>
        </Row>
      )}
      <Row>
        <FieldArray
          name="adults"
          component={AdultFields}
          deleteAdult={props.deleteAdult}
          primaryResidentId={props.primaryResidentId}
          onPrimaryChange={props.onPrimaryChange}
          leaseLocked={leaseLocked}
          householdHasOpenCerts={householdHasOpenCerts}
          prevPrimaryId={props.prevPrimaryId}
          change={props.change}
        />
      </Row>
      <div className="row">
        <a className="btn-text" onClick={props.addAdult} disabled={leaseLocked}>
          + Add Adult
        </a>
      </div>
    </div>
  );
}

export default connect(
  createStructuredSelector({
    applicationType: appSelectors.getSelectedPropertyClassType,
    isAffordableApplication: residentSelectors.isAffordableApplication,
  }),
  {},
)(Adults);
